import SingleModelInterface from '../../types/singleModelInterface'
import Specialization from './specialization'

export function shouldDisableBusinessTab(
    carsFilteredByDealer: SingleModelInterface[]
): boolean {
    return (
        !carsFilteredByDealer.some(
            (car) => car.specialization === Specialization.PRODOTTI_COMMERCE
        ) ||
        carsFilteredByDealer
            .filter(
                (car) => car.specialization === Specialization.PRODOTTI_COMMERCE
            )
            .every((car) => car.in_specialization === 0)
    )
}
